import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ColumnChartConfig } from '../../../../../shared/google-chart/Models/ColumnChartConfig';
import { ChartUtil } from '../../../../../shared/services/utility/chart.service';
import { SiteDashboardService } from '../../../site-dashboard.service';
import { CommonUtil } from '../../../../../shared/services/utility/common.service';
import { ngxCsv } from 'ngx-csv/ngx-csv';
import * as moment from 'moment';

@Component({
  selector: 'app-plinks-output',
  templateUrl: './plinks-output.component.html',
  styleUrls: ['./plinks-output.component.css']
})
export class PlinksOutputComponent implements OnInit, OnChanges {
  @Input() data: any;
  @Input() siteId: number = 0;
  @Input() customerId: number = 0;
  @Input() sitePlinksData: any = {};
  @Input() siteTags: any = {};
  @Input() sitePlinksTags: any = {};
  @Input() customerName: string = '';
  @Input() siteName: string = '';

  config: ColumnChartConfig;
  tableColumns: any[] = [
    {title: "PolarLink ID", property: "deviceId"},
    {title: "PolarLink SN", property: "serialNumber"},
    {title: "Value", property: "TotalBillableEnergykWh"}
  ];
  filteredData: any;
  title: string = 'PolarLink KWHrs Output';
  tooltipText: string = 'Displays exact energy output from individual polarlink devices. Useful for performance comparisons.';
  elementId: string = 'plinks-output';
  widgetClass: string = 'auto-height-widget';
  siteWidgetOptions: any = {
    hasOperation: false,
    hasChargerModels: false,
    hasDate: true,
    isSitePerformanceWidget: true,
    isChargers: false,
    isPlink: true,
    hideYesterdayDate: true,
    filterOutZeroValues: true,
    excludeSinceInstallationOption: true
  };

  constructor(private chartUtil: ChartUtil, private siteDashboard: SiteDashboardService, private commonUtil: CommonUtil) { }

  async ngOnInit() {
    this.config = new ColumnChartConfig({
      isPercent: false,
      yTitle: "KWHrs",
      widgetHeight: 400,
      chartArea: {top: 10, width:'70%', height:'80%'},
      vAxisMinValue: 0,
      tooltip: {trigger: 'hover'},
      hAxis:{
        textPosition: 'none'
      }
    });

    this.config.formatFunction = (data) => {
      data = data || [];
      data = data.filter((item: any) => item.TotalBillableEnergykWh > 0);
      let formattedData: any[] = [
        [
          {"label": "Polar Link Device", "type": "string"},
          {"label": "KWhr", "type": "number"},
          {"type": "string", role: 'annotation'},
          {"type": "string", role: 'style'},
        ]
      ];
      let idColors = {};
      let colors = [
      { color: '#3aaed8' },
      { color: '#2d5e96' },
      { color: '#60e6e9' },
			{ color: '#4d4e9bff' },
			{ color: '#2d5e96' }, // Fixed missing # in color code
			{ color: '#5aa3c2ff' },
      { color: '#32336c' },
			{ color: '#87b5e9ff' },
			{ color: '#238ab7' },
			{ color: '#724d83' }, // Fixed missing # in color code
		];
    let color = "";

      for(let i = 0; i < data.length; i++) {
        let kwData: any = data[i];
        let kw = kwData.TotalBillableEnergykWh;
        color = idColors.hasOwnProperty(kwData.deviceId) ? idColors[kwData.deviceId] : colors[Object.keys(idColors).length].color;
        idColors[kwData.deviceId] = color;
        
        formattedData.push(
          [
            {v: kwData.deviceId || 'PolarLink ' + (i + 1)},
            {v: kw },
            {v: ''},
            {v: `color: ${color}`}
          ]
        );
      }

      return formattedData;
    };
  }

  eventEmit(event: {type: string, data: any}) {
      switch (event.type) {
        case "export":
        let exportFilters = this.commonUtil.getExportWidgetFiltersInfo(event.data);
        let csvData: any = [
          {a: "Site: " + this.customerName + "/" + this.siteName}
        ];
  
        for (let key in exportFilters) {
          csvData.push({ a: exportFilters[key] });
        }
  
        csvData.push({ a: "Date of print: " + moment().format("LL") }, {}); // Date of print & an empty row
        csvData.push({
          a: "PolarLink ID",
          b: "PolarLink SN",
          c: "Value",
        });
  
        for (let range in this.filteredData) {
          let devices = this.filteredData[range].list;
    
          if (devices) {
          devices.forEach((device: any) => {
            csvData.push({
            a: device.deviceId,
            b: device.serialNumber,
            c: device.value});
          });
          }
        }
  
        let fileName = `${this.title} - ${this.customerName} / ${this.siteName}`;
        new ngxCsv(csvData, fileName);
        break;
    
        case "filteredData":
        this.filteredData = event.data;
        break;
      }
    }

  ngOnChanges() {
    // Data processing is handled by the formatFunction
  }
}
